export const POSITIONS_URL = "/positions";
export const COMMITTEES_URL = "/committees";
export const SIGN_IN_URL = "/sign-in";
export const SIGN_UP_URL = "/sign-up";
export const FORGOT_PASSWORD_URL = "/forgot-password";
export const MEMBERS_URL = "/member";
export const CREATE_MEMBERS_URL = "/member/create-member";
export const MEMBER_DETAIL_URL = "/member/member-detail";
export const PRINT_MEMBER_URL = "/member/member-detail/print";
export const MEMBER_SAVED_SEARCH_URL = "/member/savedsearch";
export const ORDER_DETAIL_URL = "/order/order-detail";
export const FIND_MEMBER_URL = "/member/findmember";
export const MEMBER_LABEL_URL = "/member-label";
export const MEMBER_EMAIL = "/member-email";
export const MEMBERS_SAVEDSEARCH_URL = "/user/savedSearch";
export const ORDER_URL = "/order";
export const CREATE_ORDER_URL = "/order/create-order";
export const UPDATE_PAYMENT_URL = "/order/update-payment";
export const EVENT_URL = "/events";
export const EVENT_DETAIL_URL = "/events/event-detail";
export const EDIT_EVENT_URL = "/events/edit-event";
export const SETTINGS_URL = "/settings";
export const CREATE_EVENT_URL = "/create-event";
export const CREATE_VIDEO_EVENT_URL = "/create-video-event";
export const INVOICE_URL = "/invoice";
export const ANALYTICS_URL = "/analytics";
export const REPORT_URL = "/reports";
export const JOB_URL = "/job";
export const LIBRARY_URL = "/library";
export const HOME_URL = "/home";
export const SIGN_UP_CONFIRMATION = "/sign-up-confirmation/:verificationString";
export const RESET_PASSWORD = "/reset-password/:verificationString";
